import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import style from './Career.module.css';

const Career = () => {
  const [career, setCareer] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    const fun = async () => {
      await axios
        .get('/career', {
          headers: { 'Access-Control-Allow-Origin': '*' },
          withCredentials: true,
        })
        .then((res) => {
          setCareer(res.data);
          setLoad(false);
        });
    };
    fun();
  }, []);

  return (
    <div>
      <div>
        <h2>Current Job Openings</h2>
        {!load ? (
          career.map((p) => {
            return (
              <div className={style.career} key={p._id}>
                <div>
                  {p.title} - {p.type}
                </div>
                <div className={style.Link}>
                  <a className={style.ink} target='_blank' rel='noreferrer' href={p.description.startsWith('http') ? p.description : `https://${p.description}`}>
                    Click Here
                  </a>
                </div>
              </div>
            );
          })
        ) : (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Career;
